import { BasicProps } from "@/types";
import classNames from "classnames";

interface IndicatorProps extends Exclude<BasicProps, "children"> {
  label: string;
  color?: string;
  hint?: string;
}

export default function Indicator(props: IndicatorProps) {
  const { label, className, hint, color = "bg-orange-400/80" } = props;
  return (
    <div
      className={classNames(
        className,
        "flex flex-row items-center justify-left pl-2",
      )}
    >
      <div className={classNames("w-2 h-4 !rounded-[2px]", color)}></div>
      <span className="text-slate-600 font-bold p-2">{label}</span>
      {hint && (
        <div className="h-full flex items-center">
          <span className="italic text-[11px] text-slate-500">({hint})</span>
        </div>
      )}
    </div>
  );
}
